import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
  Alert,
} from "reactstrap";
import { IoMdPlay } from "react-icons/io";
import comum from "../../../helpers/comum";
import RenderParamInpunt from "./RenderInputParam";

function ModalParamRun({ modal, setModal, onRun, load, lastResult }) {
  const toggle = () => {
    if (!load) setModal(null);
  };
  const [form, setForm] = useState({});

  const onChange = (_, key, value) => {
    setForm((f) => {
      return {
        ...f,
        [key]: value,
      };
    });
  };

  return (
    <form>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Entrada de Fluxo
          <br />
          <span style={{ fontSize: 10 }}>
            Adicione esses parametsros para seguir com o fluxo
          </span>
        </ModalHeader>
        <ModalBody>
          {modal?.map((e) => (
            <RenderParamInpunt
              data={e}
              id_node=""
              onParamChange={onChange}
              options={[]}
              textOnly={true}
            />
          ))}
          {lastResult && (
            <Alert
              color={lastResult?.status ? "success" : "danger"}
              style={{
                padding: 0,
                marginBottom: 0,
                marginLeft: 10,
                marginRight: 5,
                marginTop: 20,
              }}
            >
              <div
                className="console-content"
                style={{ padding: 0, margin: 0 }}
              >
                {lastResult.console ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: 10,
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}
                  >
                    <span className="console-line">
                      {lastResult.status
                        ? "Workflow executado com sucesso!"
                        : "Erro ao executar o workflow."}
                      <br /> <br />
                      Iniciou: {comum.ParseDate(lastResult.start_date)}
                      <br />
                      Terminou: {comum.ParseDate(lastResult.end_date)}
                    </span>
                  </div>
                ) : (
                  <p style={{ opacity: 0.3, fontStyle: "italic" }}>
                    Neste console, você poderá visualizar tanto os resultados
                    quanto os erros gerados pela execução da função.
                  </p>
                )}
              </div>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" disabled={load} onClick={toggle}>
            Cancelar
          </Button>
          <Button
            onClick={() => onRun(form)}
            className="button-mid-height"
            color="success"
            type="submit"
            disabled={load}
          >
            {!load ? <IoMdPlay /> : <Spinner size="sm" />} Rodar
          </Button>
        </ModalFooter>
      </Modal>
    </form>
  );
}

export default ModalParamRun;
